import api from "./api";
import { GISProperty } from "../types/gis";
import { API_ENDPOINTS } from "../constants/API_ENDPOINTS";

const getGisProperties = async (): Promise<GISProperty[]> => {
  const response = await api.get(API_ENDPOINTS.GET_GIS_PROPERTIES);
  return response.data;
};

const getGisProperty = async (parcelId: string): Promise<GISProperty> => {
  const response = await api.get(
    `${API_ENDPOINTS.GET_GIS_PROPERTY}${parcelId}`
  );
  return response.data;
};

const gisService = {
  getGisProperties,
  getGisProperty,
};

export default gisService;
